const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全天候更新，票房黑马、争议事件、明星动态第一时间推送到你面前，比其他平台平均快30分钟以上。',
  },
  {
    icon: 'ri-spy-line',
    title: '独家揭秘',
    desc: '资深娱记团队深入片场与后台，每日产出50+独家幕后花絮、明星专访与行业深度报道，内容你只在这里看得到。',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: '数据驱动',
    desc: '综合票房、评分、讨论热度等多维数据，呈现最客观的影视榜单与分析，帮你做出更明智的观影选择。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[960px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            为什么数百万影迷选择51电影网作为首选影视资讯平台
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {features.map((feature, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer text-center"
              >
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                  <i className={`${feature.icon} text-2xl text-primary-600`}></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}